import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../redux/authSlice';
import { notification, Form, Input, Button, Card, Typography, Divider, Space } from 'antd';
import { LockOutlined, UserOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const { Title, Text } = Typography;

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const { error } = useSelector((state) => state.auth);
  const [form] = Form.useForm();

  const onFinish = async ({ username, password }) => {
    setLoading(true);
    const result = await dispatch(loginUser({ username, password }));
    setLoading(false);

    form.setFieldsValue({
      username: '',
      password: ''
    });
    setFormKey(prev => prev + 1);

    if (loginUser.fulfilled.match(result)) {
      navigate('/dashboard', { replace: true });
    } else {
      api.error({
        message: 'Ошибка входа',
        description: 'Неверный логин или пароль',
        // description: error || 'Неверный логин или пароль',
        placement: 'topRight',
        duration: 4.5,
      });
    }
  };

  return (
    <>
      {contextHolder}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Card style={{ marginTop: "10%" }}>
          <Space direction="vertical" size="large">
            <Title level={3}>Вход в HR-платформу</Title>
            <Text type="secondary">Введите ваши учетные данные</Text>
            <Divider />
            <Form key={formKey} form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item name="username" rules={[{ required: true, message: 'Введите имя пользователя' }]}>
                <Input prefix={<UserOutlined />} placeholder="Имя пользователя" size="large" />
              </Form.Item>
              <Form.Item name="password" rules={[{ required: true, message: 'Введите пароль' }]}>
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Пароль"
                  size="large"
                  iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                />
              </Form.Item>
              <Button type="primary" htmlType="submit" block size="large" loading={loading}>
                Войти
              </Button>
            </Form>
            {/* <div style={{ textAlign: 'center' }}>
              <Text>Ещё нет аккаунта? </Text>
              <Link to="/register">Зарегистрироваться</Link>
            </div> */}

          </Space>
        </Card>
      </div>
    </>
  );
};

export default LoginPage;

